// extracted by mini-css-extract-plugin
export default {"btns_deletedModal":"DeletedModal_btns_deletedModal__75Yxw"};